export function arrayToMap<T>(items: T[], keySelector: (item: T) => string): { [key: string]: T | undefined } {
  return items.reduce(
    (acc, item) => {
      acc[keySelector(item)] = item;

      return acc;
    },
    {} as { [key: string]: T },
  );
}

export function sortFn<T, U>(fieldExtractor: (val: T) => U, descending: boolean = false): (l: T, r: T) => -1 | 0 | 1 {
  return (l: T, r: T) => {
    const lValue = fieldExtractor(l);
    const rValue = fieldExtractor(r);

    return descending ? (lValue > rValue ? -1 : lValue == rValue ? 0 : 1) : lValue > rValue ? 1 : lValue == rValue ? 0 : -1;
  };
}

export function partition<T>(items: T[], predicate: (item: T, i: number) => boolean): [T[], T[]] {
  return items.reduce(
    (acc, item, i) => {
      const bucket = predicate(item, i) ? acc[0] : acc[1];
      bucket.push(item);

      return acc;
    },
    [[], []] as [T[], T[]],
  );
}

export function any<T>(array: T[], predicate: (item: T) => boolean): boolean {
  return !!array.find(predicate);
}
